/* src/app/add-contact-details-slider/add-contact-details-slider.component.scss */
.add-contact {
  width: 100%;
}
.add-contact form label {
  font-size: 14px;
  color: #484b59;
  margin-top: 20px;
}
.add-contact form div input {
  width: 96%;
  display: block;
  padding: 6px 12px 6px 12px;
  border-radius: 2px;
  border: solid 1px #d9d9d9;
  background-color: #fff;
}
.add-contact form div input:focus {
  outline: #2e93a1;
  border: solid 1px 32000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000a1;
}
.professional:last-child .addAnotherContact {
  visibility: visible !important;
}
.personal:last-child .addAnotherContact {
  visibility: visible !important;
}
.contactnumber:last-child .addAnotherContact {
  visibility: visible !important;
}
.errorMessage {
  margin-top: 4px;
  font-size: 12px;
  color: #cd0f0f;
}
.addAnotherContact {
  visibility: hidden;
  margin-bottom: 0;
  margin-top: 10px;
  font-size: 12px;
  font-weight: 500;
  color: #2e93a1;
  cursor: pointer;
}
.deleteFormBtn {
  padding: 6px;
  cursor: pointer;
}
/*# sourceMappingURL=add-contact-details-slider.component-C23WPECV.css.map */
